import React, { Fragment } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStateContext } from "core/auth/hooks";
import { AppSplash } from "components/skeletons";

interface Props {
    children: React.ReactNode;
};

export const AuthGuard = ({children}: Props) => {
    const {isAuth, isLoading} = useAuthStateContext();

    if (isLoading) { return (<AppSplash />); }
    return isAuth ? (<Fragment>{children}</Fragment>) : <Navigate to='/auth' />;
};